import { Component, Input, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { Project, ProjectStatsConfiguration } from '../../../interfaces/project';
import { ProjectKpiService, KPICalculation } from '../../../services/project-kpi.service';
import { Router } from '@angular/router';

@Component({
	selector: 'bb-kpi-block',
	templateUrl: './bb-kpi-block.component.html',
	styleUrls: ['./bb-kpi-block.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BbKpiBlockComponent implements OnInit, OnChanges {
	@Input() kpi: KPICalculation; // required properties: finalSum, label
	@Input() selected?: boolean;
	@Input() loading?: boolean;

	@Input() project?: Project; // for project kpi
	@Input() statsConfiguration?: ProjectStatsConfiguration; // for project kpi
	@Input() mode?: 'sidebar' | 'no-select'; // both modes display without interaction (+ sidebar white bg)

	@Output() selectedBlock = new EventEmitter<any>();

	constructor(
		protected projectKpiService: ProjectKpiService,
		protected router: Router,
		private changeDetector: ChangeDetectorRef
	) {
	}

	ngOnInit() { }

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.project) {
			// to make bb-tooltip disappear after hover
			this.changeDetector.detectChanges();
		}
	}

	selectBlock(kpi: KPICalculation) {
		this.selectedBlock.emit(kpi);
	}

	navigateToKpi(kpi: KPICalculation, id: string) { //
		const dateRange = { startDate: this.statsConfiguration.statsDateStart, endDate: this.statsConfiguration.statsDateEnd };
		this.router.navigate(['/library/project', id, 'analysis'], { state: { dateRange, kpiId: kpi.id } });
	}
}
